import { api } from "@/lib/api";

const SW_PATH = "/sw.js";

export function isPushSupported() {
  return typeof window !== "undefined"
    && "serviceWorker" in navigator
    && "PushManager" in window
    && "Notification" in window;
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

async function getRegistration() {
  const existing = await navigator.serviceWorker.getRegistration(SW_PATH);
  if (existing) return existing;
  return navigator.serviceWorker.register(SW_PATH);
}

export async function getPushStatus() {
  if (!isPushSupported()) return { supported: false, permission: "denied", subscribed: false };
  try {
    const reg = await getRegistration();
    const sub = await reg.pushManager.getSubscription();
    return {
      supported: true,
      permission: Notification.permission,
      subscribed: !!sub,
    };
  } catch {
    return { supported: true, permission: Notification.permission, subscribed: false };
  }
}

export async function subscribePush() {
  if (!isPushSupported()) throw new Error("Browser non supporta le notifiche push");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permesso negato");

  const { data: keyResp } = await api.get("/push/public-key");
  if (!keyResp.key) throw new Error("Push non configurato");

  const reg = await getRegistration();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(keyResp.key),
    });
  }

  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: { p256dh: json.keys.p256dh, auth: json.keys.auth },
    expirationTime: sub.expirationTime || null,
  });
  return true;
}

export async function unsubscribePush() {
  if (!isPushSupported()) return false;
  const reg = await getRegistration();
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch { /* ignore */ }
    await sub.unsubscribe();
  }
  return true;
}
